export default "__VITE_PUBLIC_ASSET__d7d76fe6__"